import React, { Component } from 'react'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox,
  Button,
} from 'react-bootstrap'
import firebase from '../modules/Firebase'

const vendorModels = {
  Roku: ["roku", "nowtv"],
  Tizen: [
    "18TV_STANDARD3",
    "18TV_STANDARD2",
    "18TV_STANDARD1",
    "18TV_PREMIUM",
    "17TV_STANDARD",
    "17TV_PREMIUM",
    "17AV_BD",
    "16TV_STANDARD2",
    "16TV_STANDARD1",
    "16TV_PREMIUM",
    "16AV_BD",
    "15TV_STANDARD2",
    "15TV_STANDARD1",
    "15TV_PREMIUM",
  ],
  Samsung: [
    "15TV_ENTRY",
    "14TV_STANDARD3",
    "14TV_STANDARD1",
    "14TV_PREMIUM",
    "14TV_ENTRY",
    "14AV_PVR",
    "1415AV_BD",
  ],
}

class AddReleaseForm extends Component {
  state = {
    formState: null,
    vendorModels: [],
    selectedModels: {},
  }

  componentWillUnmount() {
    if (this.stateTimeout) {
      clearTimeout(this.stateTimeout)
    }
  }

  formToState = (e) => {
    e.persist()
    const vendorModelsKey = e.target.id === 'platform'
      ? e.target.value
      : this.state.platform
    this.setState({
      [e.target.id]: e.target.value,
      vendorModels: vendorModelsKey ? vendorModels[vendorModelsKey] : []
    })
  }

  modelsToState = (e) => {
    e.persist()
    if (!e.target.checked) {
      const {
       [e.target.id]: id,
        ...rest,
      } = this.state.selectedModels
      this.setState({
        selectedModels: rest
      })
      return
    }
    this.setState({
      selectedModels: {
        ...this.state.selectedModels,
        [e.target.id] : e.target.checked,
      }
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    const {
      platform,
      version,
      vendorVersion,
      keyChanges,
      releaseDate,
      selectedModels: models,
    } = this.state

    if (!platform || !version || !releaseDate) {
      this.showState('error')
      return
    }
    const newBuildKey = firebase.database().ref(`releases/packagedApps/${platform}`).push().key
    firebase.database().ref(`releases/packagedApps/${platform}/${newBuildKey}`).set({
      version,
      vendorVersion,
      keyChanges,
      releaseDate,
      models,
    }).then(() => (
      this.showState('success', this.props.onSuccess)
    ))
  }

  showState = (state, cb) => {
    this.setState({
      formState: state,
    })
    this.stateTimeout = setTimeout(() => {
      this.setState({
        formState: null,
      })
      if (cb) {
        cb()
      }
    }, 3000)
  }

  render() {
    const { formState, vendorModels } = this.state
    return (
      <form>
        <FormGroup validationState={formState}>
          <ControlLabel>Platform</ControlLabel>
          <FormControl componentClass="select" id="platform" placeholder="select" onChange={this.formToState} >
            <option></option>
            <option value="Roku">Roku</option>
            <option value="Tizen">Tizen</option>
            <option value="Samsung">Samsung</option>
          </FormControl>
          <ControlLabel>Version</ControlLabel>
          <FormControl
            id="version"
            type="text"
            placeholder="e.g 3.6.0"
            onChange={this.formToState}
            required
          />
          <ControlLabel>Vendor Version</ControlLabel>
          <FormControl
            id="vendorVersion"
            type="text"
            placeholder="e.g 4.0.11"
            onChange={this.formToState}
            required
          />
          <ControlLabel>Key Changes</ControlLabel>
          <FormControl componentClass="textarea" placeholder="A short description of the changes included in this release." id="keyChanges" onChange={this.formToState} required />
          <FormGroup id="models">
            <ControlLabel>Models</ControlLabel>
            {vendorModels.map((model, i) => <Checkbox key={model + i} id={model} onChange={this.modelsToState}>{model}</Checkbox>)}
          </FormGroup>
          <ControlLabel>Release Date</ControlLabel>
          <FormControl type="date" id="releaseDate" onChange={this.formToState} required />
          <FormControl.Feedback />
        </FormGroup>
        <Button bsStyle="primary" onClick={this.onSubmit}>Submit</Button>
      </form>
    )
  }
}

export default AddReleaseForm


// WEBPACK FOOTER //
// ./src/components/AddReleaseForm.js